const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY;
const GOOGLE_FOLDER_ID = process.env.REACT_APP_GOOGLE_FOLDER_ID;
const GOOGLE_API_URL = process.env.REACT_APP_GOOGLE_API_URL;

export interface GoogleDriveFile {
  id: string;
  name: string;
  mimeType: string;
  createdTime: string;
  size: number;
  description?: string;
}

export interface GoogleDriveResponse {
  files: GoogleDriveFile[];
}

export class GoogleDriveService {
  static async listFiles(): Promise<GoogleDriveFile[]> {
    if (!GOOGLE_API_KEY || !GOOGLE_FOLDER_ID || !GOOGLE_API_URL) {
      throw new Error('Configurações do Google Drive não encontradas');
    }

    const url = `${GOOGLE_API_URL}/files?q='${GOOGLE_FOLDER_ID}'+in+parents&key=${GOOGLE_API_KEY}&fields=files(id,name,mimeType,createdTime,size,description)&orderBy=createdTime desc`;

    try {
      const response = await fetch(url);
      
      if (!response.ok) {
        throw new Error(`Erro HTTP: ${response.status} - ${response.statusText}`);
      }

      const data: GoogleDriveResponse = await response.json();
      
      // Converter size de string para number
      return (data.files || []).map(file => ({
        ...file,
        size: parseInt(file.size as unknown as string) || 0
      }));
    } catch (error) {
      console.error('Erro ao buscar arquivos do Google Drive:', error);
      throw new Error('Erro na requisição para Google Drive API');
    }
  }

  static generateDownloadUrl(fileId: string): string {
    return `https://drive.google.com/uc?export=download&id=${fileId}`;
  }

  static formatFileSize(bytes?: number): string {
    if (!bytes || bytes === 0) return '0 B';
    const k = 1024;
    const sizes = ['B', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  }

  static formatDate(dateString: string): string {
    if (!dateString) return 'Data não disponível';
    
    try {
      const date = new Date(dateString);
      
      // Verifica se a data é válida
      if (isNaN(date.getTime())) {
        return 'Data inválida';
      }
      
      return new Intl.DateTimeFormat('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      }).format(date);
    } catch (error) {
      console.error('Erro ao formatar data:', error);
      return 'Data não disponível';
    }
  }

}